import styled from 'styled-components';
import Button, { ButtonProps } from './button';
import { Size as ButtonSize, sizes } from './styles';

const iconFontSizes: Record<ButtonSize, { iconFontSize?: string }> = {
  auto: {
    iconFontSize: undefined,
  },
  xs: {
    iconFontSize: '0.75rem',
  },
  sm: {
    iconFontSize: '1rem',
  },
  md: {
    iconFontSize: '1.25rem',
  },
  lg: {
    iconFontSize: '1.5rem',
  },
  xl: {
    iconFontSize: '2.5rem',
  },
};

export interface SquareButtonProps extends ButtonProps {
  'aria-label': string;
}

const SquareButton = styled(Button)<SquareButtonProps>`
  width: ${props => sizes[props.size || 'lg'].height};
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  & > i:only-child {
    /** when adding icon as direct child,
		force font-size to come from button style rather than Icon size prop */
    font-size: ${props => iconFontSizes[props.size || 'lg'].iconFontSize};
  }
`;

export default SquareButton;
